import Router from "@/routes";
import { sendInvite, getUsers, getSummary } from "@/api/organisation";
import { signin, googleSignIn, register } from "@/api/auth";
import Console from "@/models/Console.model";
import SummaryMetric from "@/models/SummaryMetric.model";
import { types } from "./mutations";
import notify from "@/lib/notifications";

export default {
  /**
   * load the details of the current user
   */
  getUserData: async ({ commit }) => {
    const name = localStorage.getItem("name");
    const email = localStorage.getItem("email");
    const token = localStorage.getItem("token");

    commit(types.SET_USER_DATA, {
      name,
      email,
      token,
    });

    return {
      name,
      email,
      token,
    };
  },

  /**
   * Sig out the current user
   */
  signOut: async ({ dispatch }) => {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    Router.push("/auth");
    dispatch("clearAll", null, { root: true });
  },

  /**
   * Set the account id of the current user
   */
  setAccountId({ commit }, accountId) {
    commit(types.SET_ACCOUNT_ID, accountId);
  },

  /**
   * Clear the current account id
   */
  clearAccountId({ commit }) {
    commit(types.SET_ACCOUNT_ID, "");
  },

  /**
   * Sign in the user with email and password
   */
  signIn: async ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      signin(payload.email, payload.password)
        .then(response => {
          if (response.status === 200 && response.data.data.token) {
            const { name, email, token } = response.data.data;
            localStorage.setItem("token", token);
            localStorage.setItem("name", name);
            localStorage.setItem("email", email);
            commit(types.SET_USER_DATA, {
              token,
              name,
              email,
            });
            notify.success(`Welcome back, ${name}!`);
          }

          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  /**
   * SignIns the user with google credentials
   */
  signInWithGoogle: async ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      googleSignIn(token)
        .then(response => {
          if (response.status === 200) {
            const { token, name, email } = response.data;
            localStorage.setItem("token", token);
            localStorage.setItem("name", name);
            localStorage.setItem("email", email);
            commit(types.SET_USER_DATA, {
              token,
              name,
              email,
            });
            notify.success(`Welcome back, ${name}!`);
          }
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  /**
   * Signs up the user with email, password name and account id
   */
  signUp: async (_, payload) => {
    return new Promise((resolve, reject) => {
      register(
        payload.name,
        payload.email,
        payload.password,
        payload.account_id || ""
      )
        .then(response => {
          if (response.status === 200) {
            notify.success(
              "Account Created!",
              "Successfully created your account, please login with the credentials."
            );
          }

          resolve(response);
        })
        .catch(error => {
          if (error.response && error.response.status === 409) {
            notify.warn(
              "Email already exists",
              "Tip: Use forgot password to change your password"
            );
          }
          reject(error);
        });
    });
  },

  /**
   * Sends an invitation link to the user
   */
  sendInvitationLink: async (_, email) => {
    return new Promise((resolve, reject) => {
      sendInvite(email)
        .then(response => {
          if (response.status === 200) {
            notify.success("Invitation Sent!", "Invitations on it's way...");
          } else {
            notify.warn(
              "Oops! Something went wrong",
              "Please check the provided email"
            );
          }
          return resolve(response);
        })
        .catch(error => {
          notify.error("Server Error", "Unable to connect to server");
          return reject(error);
        });
    });
  },
};
